/**
 * ContentUsersLikedSheet
 *
 * Wrapper that opens the owner-only "users who liked this" UI via SheetService.
 * Mirrors Flutter's `ContentUsersLikedBottomSheet` entry point — the
 * drag-to-dismiss bottom sheet becomes a `SheetService`-driven sheet (allowed
 * web UI deviation).
 *
 * The like-count title is rendered inside the content (matching Flutter's
 * `appBarTitle`), so the sheet `title` is left empty.
 */

import { SheetService } from '@/presentation/components/common/sheet/service/SheetService';
import { ContentUsersLikedContent } from './ContentUsersLikedContent';

export interface ShowContentUsersLikedSheetParams {
  mediaPath: string;
  likes: number;
  container?: HTMLElement | string | null;
  screenKey?: string;
  fixedHeight?: string;
}

const show = ({
  mediaPath,
  likes,
  container,
  screenKey,
  fixedHeight = '85dvh',
}: ShowContentUsersLikedSheetParams) => {
  SheetService.show({
    title: '',
    content: <ContentUsersLikedContent mediaPath={mediaPath} likes={likes} />,
    container,
    screenKey,
    fixedHeight,
    scrollable: false,
  });
};

export const ContentUsersLikedSheet = {
  show,
};
